<template>
   <g>
      <path
         d="M4.61111 1H1.72222C1.32335 1 1 1.32335 1 1.72223V4.61116C1 5.01004 1.32335 5.33339 1.72222 5.33339H4.61111C5.00998 5.33339 5.33333 5.01004 5.33333 4.61116V1.72223C5.33333 1.32335 5.00998 1 4.61111 1Z"
         stroke="white"
         stroke-linecap="round"
         stroke-linejoin="round"
      />
      <path
         d="M1 9.6633L2.44444 11.1078L5.33333 8.21884M8.22222 1.71875H14M8.22222 6.05214H14M8.22222 10.3855H14"
         stroke="white"
         stroke-linecap="round"
         stroke-linejoin="round"
      />
   </g>
</template>

<script>
export default {
   data() {
      return {
         name: 'icon-questions',
         viewBox: '0 0 15 12',
         width: 15,
         height: 12,
         fill: 'none',
      };
   },
};
</script>
